































































































































































































































import CollapseTransition from '@/components/collapseTransition/collapseTransition'; // 导入过渡函数
import { Component, Prop, Vue } from 'vue-property-decorator';
import { TableStripe } from '@/mixins/tableStripe';
import { dictServe, performanceServer, regionServe } from '@/api/installServer';
import publishObjectPath from '@/util/configRegistry';
import { arrayToTree } from '@/util/array';
import EditHazardDialog from './editHazardDialog.vue';

@Component({
  components: { CollapseTransition, EditHazardDialog },
  mixins: [TableStripe],
})
export default class CheckingPage extends Vue {
  @Prop(Object) rowId: any;
  private serverUrl = publishObjectPath.imgPathWater;
  private formData: any = {
    checkItems: [],
  }; // 检查单详情
  private formDataHazards: any = {}; // 检查单隐患
  private hazardTypeList: any = [];
  private hazardLevelList: any = [];
  private spaceAreaList: any = [];
  private groupHazardCategoryList: any = [];
  private rectificationMeasuresList: any = [];

  height = '300'; // 表格的高度
  isShow = true;
  isShow1 = true;

  // 以下是 添加隐患的form 用到的数据
  hiddenForm: any = {
    hazardType: '', // 隐患类型
    hazardTypeLabel: '', // 隐患类型 文本
    hazardDiscoverDate: '', // 隐患时间
    hazardLevel: '', // 隐患等级
    hazardContent: '', // 隐患内容
    rectifySuggestion: '', // 整改建议
    rectificationMeasures: '', // 整改建议
    hazardPicture: '', // 隐患图片, 可以多个, 逗号分割字符串
    taskId: '', // 一行的id
    itemId: '', // 检查内容选择的id
    areaId: '', // 区域
    groupHazardCategoryCode: '', // 区域
    groupHazardCategoryLabel: '', // 区域
  };
  fileList: any = [];
  headers: any = {};
  actionUrl: any = ''; // 图片上传
  allPeople: any = [];

  private hiddenFormRules = {
    groupHazardCategoryCode: [{ required: true, message: '请选择隐患分类', trigger: 'blur' }],
    hazardType: [{ required: true, message: '请选择隐患分类', trigger: 'blur' }],
    hazardDiscoverDate: [{ required: true, message: '请选择上报时间', trigger: 'blur' }],
    hazardLevel: [{ required: true, message: '请选择隐患级别', trigger: 'blur' }],
    hazardContent: [{ required: true, message: '请输入隐患内容', trigger: 'blur' }],
    rectifySuggestion: [{ required: true, message: '请输入整改建议', trigger: 'blur' }],
    rectificationMeasures: [{ required: true, message: '请选择整改措施', trigger: 'change' }],
  };

  private isShowDetail() {
    this.isShow = !this.isShow;
  }

  private isShowHazardList() {
    this.isShow1 = !this.isShow1;
  }

  created() {
    this.getTemplateDetail();
    this.getHazardTypeList(); // 隐患分类
    this.getHazardLevelList(); // 隐患级别
    this.getRectificationMeasuresList(); // 隐患级别
    this.getGroupHazardCategoryList(); // 隐患级别
    this.getSpaceAreaData(); // 获取区域列表
  }

  private getTemplateDetail() {
    performanceServer.getTemplateDetail(this.rowId.id).then((res: any) => {
      if (res.code === '200') {
        this.formDataHazards = res.data.hazards.filter((item: any) => !item.rectifyFormId);
        // this.formDataHazards = res.data.hazards;
        const arrStaff: any = res.data.joinStaffList.concat(res.data.executors);
        this.allPeople = this.unique(arrStaff);
        if (this.formDataHazards.length) {
          this.formDataHazards.forEach((item: any) => {
            if (item.hazardPicture) {
              this.$set(item, 'hazareHelpArr', []);
              this.getSysFile(item);
            }
          });
        }
        this.formData = res.data;
      } else {
        this.$message.warning(res.msg);
      }
    });
  }

  private unique(arr: any) {
    for (let i = 0; i < arr.length; i++) {
      for (let j = i + 1; j < arr.length; j++) {
        if (arr[i].staffId === arr[j].staffId || arr[i].staffId === undefined || arr[j].staffId === undefined) {
          // 第一个等同于第二个，splice方法删除第二个
          arr.splice(j, 1);
          j--;
        }
      }
    }
    return arr;
  }

  // 获取隐患类型的列表
  async getHazardTypeList() {
    const res: any = await performanceServer.customRelevanceData({
      type: 'hazardClassify',
    });
    if (res.code === '200') {
      res.data.forEach((item: any) => {
        this.callbackHazardTypeList(item);
      });
      this.hazardTypeList = res.data;
    } else {
      this.$message.warning('获取隐患类型的数据失败！');
    }
  }

  private callbackHazardTypeList(data: any) {
    if (data.children.length) {
      data.children.forEach((item: any) => {
        this.callbackHazardTypeList(item);
      });
    }
    if (!data.children.length) {
      delete data.children;
    }
  }

  // 获取隐患等级的列表
  getHazardLevelList() {
    dictServe.getDetailsMapByName('securityCheckHazardLevel').then((res: any) => {
      if (res.code === '200') {
        const dictData: any = [];
        for (const key in res.data) {
          dictData.push({
            value: key,
            label: res.data[key],
          });
        }
        this.hazardLevelList = dictData;
      } else {
        this.$message.warning('获取隐患等级的列表数据失败！');
      }
    });
  }
  // 整改措施
  getRectificationMeasuresList() {
    dictServe.getDetailsMapByName('rectificationMeasures').then((res: any) => {
      if (res.code === '200') {
        const dictData: any = [];
        for (const key in res.data) {
          dictData.push({
            value: key,
            label: res.data[key],
          });
        }
        this.rectificationMeasuresList = dictData;
      } else {
        this.$message.warning('获取整改措施的列表数据失败！');
      }
    });
  }

  getGroupHazardCategoryList() {
    dictServe.getDetailsMapByName('groupHazardCategory').then((res: any) => {
      if (res.code === '200') {
        const dictData: any = [];
        for (const key in res.data) {
          dictData.push({
            value: key,
            label: res.data[key],
          });
        }
        this.groupHazardCategoryList = dictData;
      } else {
        this.$message.warning('获取隐患等级的列表数据失败！');
      }
    });
  }

  // 获取区域列表
  getSpaceAreaData() {
    regionServe.getRegionAllData({}).then((res: any) => {
      if (res.code === '200') {
        this.spaceAreaList = arrayToTree(res.data);
      } else {
        this.$message.warning('获取区域的列表失败！');
      }
    });
  }

  // 以下都是检查内容表格的
  /**
   * @description 将选中的数组赋值给传递的数组
   */
  tableChange(selection: any, row?: any) {
    (this.$refs.multipleTable as any).clearSelection();
    const selected = selection.length && selection.indexOf(row) !== -1; //为true时选中，为 0 时（false）未选中
    if (selected) {
      (this.$refs.multipleTable as any).toggleRowSelection(row, true);
      this.hiddenForm.itemId = row.id;
      if (row.other) {
        const str: any = JSON.parse(row.other);
        this.hiddenForm.hazardContent = str.riskControlRunawayShow ? str.riskControlRunawayShow : '';
      } else {
        this.hiddenForm.hazardContent = '';
      }
    } else {
    }
  }

  private saveHiddenForm() {
    const formComponent: any = this.$refs['formRef'];
    formComponent.validate((valid: any) => {
      if (!valid) return;
      const arr: any = (this.$refs.hazardTypeRef as any).getCheckedNodes();
      if (!arr[0]) {
        this.hiddenForm.hazardTypeLabel = '';
      } else {
        this.hiddenForm.hazardTypeLabel = arr[0].label;
      }
      if (this.hiddenForm.groupHazardCategoryCode) {
        const findData: any = this.groupHazardCategoryList.find((item: any) => item.value === this.hiddenForm.groupHazardCategoryCode);
        this.hiddenForm.groupHazardCategoryLabel = findData.label;
      } else {
        this.hiddenForm.groupHazardCategoryLabel = '';
      }
      this.addHazardMethod();
    });
  }

  // 保存添加了的单条隐患
  private addHazardMethod() {
    performanceServer.addHazard(this.hiddenForm).then((res: any) => {
      if (res.code === '200') {
        this.$message.success('添加成功！');
        /* 刷新页面并清空表单 */
        this.getTemplateDetail();
        this.$forceUpdate();
        this.clearForm();
      } else {
        this.$message.warning(res.msg);
      }
    });
  }

  private clearForm() {
    this.fileList = [];
    this.hiddenForm.itemId = '';
    (this.$refs.formRef as any).resetFields();
  }

  private backToIndex() {
    this.clearForm();
    this.$emit('backToIndex');
  }

  // 图片回显的接口
  private getSysFile(data: any) {
    if (data.hazardPicture) {
      performanceServer.getSysFile(data.hazardPicture).then((res: any) => {
        if (res.code === '200' && res.data.length > 0) {
          data.hazareHelpArr = res.data;
        }
      });
    }
  }

  private handleSuccess(response: any, file: any, fileList: any) {
    const arr: any = [];
    fileList.forEach((item: any) => {
      if (item.response.data) {
        arr.push(item.response.data[0].id);
      }
    });
    this.hiddenForm.hazardPicture = arr.toString(); // 存放选择的隐患图片
  }

  private handleRemove(file: any, fileList: any) {
    const arr: any = [];
    fileList.forEach((item: any) => {
      if (item.response.data) {
        arr.push(item.response.data[0].id);
      }
    });
    this.hiddenForm.hazardPicture = arr.toString(); // 存放选择的隐患图片
  }

  private delHazard(id: any) {
    this.$confirm('此操作将永久删除该隐患, 是否继续?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    })
      .then(() => {
        performanceServer.delSecurityCheckHazard(id).then((res: any) => {
          if (res.code === '200') {
            this.$message.success('成功删除该条数据');
            this.getTemplateDetail();
          }
        });
      })
      .catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除',
        });
      });
  }

  private editHazard(id: any) {
    (this.$refs.EditHazardDialogRef as any).showDialog(this.formData.checkItems, id);
  }

  updateDetailData() {
    this.getTemplateDetail();
  }

  mounted() {
    this.actionUrl = publishObjectPath.serverUrl + '/api/sysManage/sysFile';
    this.headers.Authorization = localStorage.getItem('token');
    this.hiddenForm.taskId = this.rowId.id; // 安全检查任务id
  }

  // 图片预览
  previewList(imgData: any) {
    const arr: any = [];
    imgData.forEach((item: any) => {
      arr.push(`${this.serverUrl}${item.path}`);
    });
    return arr;
  }
}
